import React, { memo } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import Typography from '@material-ui/core/Typography'
import LOG from '../../logging/Logger'

const SettingsSection = memo(
  ({ handleExpanderChange, expanded, panelName, title, children }) => {
    LOG.debug('Render: SettingsSection')

    return (
      <Accordion
        expanded={expanded === panelName}
        onChange={handleExpanderChange(panelName)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1d-content'
          id='panel1d-header'
        >
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>{children}</div>
        </AccordionDetails>
      </Accordion>
    )
  }
)

export default SettingsSection
